// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../styles/colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/dark_background.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/images/logos/VEClim-Logo-monochrome-white-200px.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/icons/menu-white-32px.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cover {
	position: relative;
}

.overlay-pic {
	/* position: fixed; */
	position: fixed;
	width: 130px;
	height: 130px;
	right: -15px;
	top: -20px;
	z-index: 4000;
	object-fit: cover;
}

.overlay-pic img {
	object-fit: cover;
	max-width: 130px;
	max-height: 130px;
	animation: rotate-layover 120s infinite linear;
}
.map-page-icon {
	position: fixed;
	z-index: 5001;
	right: 0.5rem;
	top: 0.5rem;
}
.map-page-icon img {
	filter: drop-shadow(0.5px 0.5px 0.3px #ffffff8b);
}

.mobile-header {
	position: fixed;
	z-index: 3000;
	max-width: 100vw;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center/cover;
	opacity: 1;
	clip-path: polygon(0 0, 100% 0, 100% 85%, 0 60%);
	/* overflow: visible; */
	overflow: hidden;
}

.burger-menu {
	display: flex;
	top: 0;
	justify-content: space-between;
	padding: 0.1rem 0.1rem;
	height: var(--mobile-nav-height);
	width: 100vw;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
		center no-repeat;
	background-position: 50% 20%;
	background-size: 40%;
	z-index: 7000;
}
.burger-menu img {
	z-index: 4000;
}

.burger-icon {
	height: 35px;
	width: 35px;
	color: white;
	padding: 3px;
	margin: 3px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-size: 32px;
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/NavBar/MobileNav/mobileNav.css"],"names":[],"mappings":"AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,UAAU;CACV,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;CACjB,8CAA8C;AAC/C;AACA;CACC,eAAe;CACf,aAAa;CACb,aAAa;CACb,WAAW;AACZ;AACA;CACC,gDAAgD;AACjD;;AAEA;CACC,eAAe;CACf,aAAa;CACb,gBAAgB;CAChB,uEAAyE;CACzE,UAAU;CACV,gDAAgD;CAChD,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,MAAM;CACN,8BAA8B;CAC9B,sBAAsB;CACtB,gCAAgC;CAChC,YAAY;CACZ;kBACiB;CACjB,4BAA4B;CAC5B,oBAAoB;CACpB,aAAa;AACd;AACA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,yDAAyD;CACzD,qBAAqB;CACrB,4BAA4B;CAC5B,2BAA2B;CAC3B,eAAe;AAChB","sourcesContent":["@import url(\"styles/colors.css\");\n\n.cover {\n\tposition: relative;\n}\n\n.overlay-pic {\n\t/* position: fixed; */\n\tposition: fixed;\n\twidth: 130px;\n\theight: 130px;\n\tright: -15px;\n\ttop: -20px;\n\tz-index: 4000;\n\tobject-fit: cover;\n}\n\n.overlay-pic img {\n\tobject-fit: cover;\n\tmax-width: 130px;\n\tmax-height: 130px;\n\tanimation: rotate-layover 120s infinite linear;\n}\n.map-page-icon {\n\tposition: fixed;\n\tz-index: 5001;\n\tright: 0.5rem;\n\ttop: 0.5rem;\n}\n.map-page-icon img {\n\tfilter: drop-shadow(0.5px 0.5px 0.3px #ffffff8b);\n}\n\n.mobile-header {\n\tposition: fixed;\n\tz-index: 3000;\n\tmax-width: 100vw;\n\tbackground: url(\"assets/images/dark_background.webp\") center center/cover;\n\topacity: 1;\n\tclip-path: polygon(0 0, 100% 0, 100% 85%, 0 60%);\n\t/* overflow: visible; */\n\toverflow: hidden;\n}\n\n.burger-menu {\n\tdisplay: flex;\n\ttop: 0;\n\tjustify-content: space-between;\n\tpadding: 0.1rem 0.1rem;\n\theight: var(--mobile-nav-height);\n\twidth: 100vw;\n\tbackground: url(\"assets/images/logos/VEClim-Logo-monochrome-white-200px.png\")\n\t\tcenter no-repeat;\n\tbackground-position: 50% 20%;\n\tbackground-size: 40%;\n\tz-index: 7000;\n}\n.burger-menu img {\n\tz-index: 4000;\n}\n\n.burger-icon {\n\theight: 35px;\n\twidth: 35px;\n\tcolor: white;\n\tpadding: 3px;\n\tmargin: 3px;\n\tbackground-image: url(\"assets/icons/menu-white-32px.png\");\n\tbackground-size: 32px;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tcursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
